import { Link } from "@mui/material";
import React from "react";
import { ListItemSmall, ListItemTextSmall } from "./listItem";

export const SideNavChat: React.FC = () => {
  return (
    <Link href={`/newchat`}>
      <ListItemSmall sx={{ pl: 2 }} data-testid="sidenav-chat">
        <ListItemTextSmall>Chat</ListItemTextSmall>
      </ListItemSmall>
    </Link>
  );
};
